export const customerCurrencyDropdown = [
  {
    label: "United States",

    code: "US",
    currency: "USD",
  },
  {
    label: "United Kingdom",

    code: "GB",
    currency: "GBP",
  },
  {
    label: "Germany",

    code: "DE",
    currency: "EUR",
  },
  {
    label: "India",

    code: "IN",
    currency: "INR",
  },
];
